module.exports = __webpack_public_path__ + "static/FT-047ff2cf008038850721e2fcf09b0f81.png";